export const VALID_TOKEN = 'VALID_TOKEN'
export const CREATE_TOKEN = 'CREATE_TOKEN'
export const INVALID_TOKEN = 'INVALID_TOKEN'
export const LOGGED_OUT = 'LOGGED_OUT'
